import React, { useRef, useState } from 'react';
import { Dropdown } from 'antd';
import { StyledIcon, StyledInput } from '@/shared/styles';
import { calendarIcon } from '@/assets/images/icons';
import { Datepicker } from './Datepicker';
import { StyledDatepickerInputWrapper } from './Datepicker.styles';
import { useDatepickerStore } from '@/stores/DatepickerStore/DatepickerStore';
import { DatepickerSingleInputProps, DatepickerType } from './Datepicker.consts';
import { useTranslation } from 'react-i18next';
import { useOutsideDropdownClick } from '@/hooks/useOutsideDropdownClick';

export const DatepickerSingleInput: React.FC<DatepickerSingleInputProps> = ({
  presetValue,
  onSelect,
}: DatepickerSingleInputProps) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const { isOpen, setIsOpen } = useDatepickerStore();
  const [value, setValue] = useState<string>(presetValue || '');
  const { t } = useTranslation();

  const onSingleDateSelect = (date: string) => {
    setValue(date);
    onSelect(date);
  };

  useOutsideDropdownClick(dropdownRef, () => {
    setIsOpen(false);
  });

  return (
    <Dropdown
      open={isOpen}
      dropdownRender={() => (
        <div ref={dropdownRef}>
          <Datepicker
            type={DatepickerType.SINGLE}
            presetDate={presetValue}
            onSingleDateSelect={onSingleDateSelect}
          />
        </div>
      )}
      placement="bottomLeft"
      trigger={['click']}
      overlayClassName="datepicker"
      getPopupContainer={() => document.querySelector('.App') as HTMLElement}
    >
      <StyledDatepickerInputWrapper>
        <StyledInput
          placeholder={t('admin.datepicker.select_date')}
          aria-label={t('admin.datepicker.select_date')}
          className="datepicker-trigger"
          value={value}
          onClick={(e) => {
            e.preventDefault();
            setIsOpen(!isOpen);
          }}
        />
        <StyledIcon src={calendarIcon} className="datepicker-input-icon" />
      </StyledDatepickerInputWrapper>
    </Dropdown>
  );
};
